module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group selectreport",
    attrs: {
      "id": "job"
    }
  }, [_c('div', {
    staticClass: "model-list"
  }, [_c('button', {
    ref: "togglebtnModel",
    staticClass: "btn toggle-model",
    attrs: {
      "rel": "togglebtnModel"
    },
    on: {
      "click": function($event) {
        return _vm.toggleModel()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('b', [_vm._v("Select a model")])]), _vm._v(" "), _c('div', {
    ref: "toggleModelMenu",
    staticClass: "dropdown-content hide-model-content"
  }, _vm._l((_vm.job), function(job, key) {
    return _c('p', {
      key: key,
      class: _vm.jobselect_unique_id === job.unique_id ? 'current-model' : '',
      attrs: {
        "value": job.unique_id,
        "selected": _vm.jobselect_unique_id === job.unique_id ? true : false
      },
      on: {
        "click": function($event) {
          _vm.selectedJob(job.id, job.unique_id, job.name);
          _vm.toggleModel()
        }
      }
    }, [_vm._v(_vm._s(job.name) + " | " + _vm._s(job.id))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "model-name"
  }, [_vm._v(_vm._s(_vm.currentJobname) + " | " + _vm._s(_vm.jobselect))])]), _vm._v(" "), _c('div', {
    staticClass: "stepsNav tabs"
  }, [_c('a', {
    class: {
      active: _vm.step1
    },
    on: {
      "click": function($event) {
        return _vm.setstep('step1')
      }
    }
  }, [_vm._v("Model Report")]), _vm._v(" "), (_vm.wrs === 1) ? _c('a', {
    class: {
      active: _vm.step2
    },
    on: {
      "click": function($event) {
        return _vm.setstep('step2')
      }
    }
  }, [_vm._v("Weekly Report")]) : _vm._e(), _vm._v(" "), (_vm.crs === 1) ? _c('a', {
    class: {
      active: _vm.step3
    },
    on: {
      "click": function($event) {
        return _vm.setstep('step3')
      }
    }
  }, [_vm._v("Credit Flow Report")]) : _vm._e()]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step1),
      expression: "step1"
    }],
    staticClass: "content step1"
  }, [_c('div', {
    staticClass: "downcsv downcsvMrep col-md-2"
  }, [(_vm.downcsvMrep.length) ? _c('a', {
    ref: "downcsvtriggerModel",
    staticClass: "btn btn-lrg btn-primary downcsvtrigger",
    attrs: {
      "href": _vm.downcsvMrep,
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download CSV\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.jobselect_unique_id.length !== 0) ? _c('vue-good-table', {
    ref: "jobtable2",
    attrs: {
      "mode": "local",
      "styleClass": "table table-bordered condensed",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "paginate": false,
      "lineNumbers": true,
      "perPage": 22,
      "sortable": true,
      "globalSearch": false,
      "name": "test"
    },
    on: {
      "on-selected-rows-change": _vm.onPageChange2
    }
  }, [_c('template', {
    slot: "loadingContent"
  }, [_c('span', {
    staticClass: "vgt-loading__content"
  }, [_c('div', {
    staticClass: "dataspinner"
  }, [_c('span', [_vm._v("Loading Data")]), _vm._v(" "), _c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])])])], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step2),
      expression: "step2"
    }],
    staticClass: "step2 clearfix"
  }, [_c('div', {
    staticClass: "downcsv col-md-2 downcsvWSR"
  }, [(_vm.downcsvWRS.length) ? _c('a', {
    ref: "downcsvtrigger",
    staticClass: "btn btn-lrg btn-primary downcsvtrigger",
    attrs: {
      "href": _vm.downcsvWRS,
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download CSV\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group selectchannel col-md-6"
  }, [_c('label', [_vm._v("Select a Channel")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selchannels),
      expression: "selchannels"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-name": "channels",
      "name": "channels"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selchannels = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectedChannel(_vm.selchannels, 'wrs')
      }]
    }
  }, _vm._l((_vm.ofthechannels), function(ofthechannels) {
    return _c('option', {
      key: ofthechannels.key,
      domProps: {
        "value": ofthechannels
      }
    }, [_vm._v(_vm._s(ofthechannels))])
  }), 0)])]), _vm._v(" "), (_vm.selchannels.length !== 0 && _vm.selchannels !== 'all_channels') ? _c('div', {
    staticClass: "chartWrapper"
  }, [_c('div', {
    staticClass: "forecast_charts"
  }, [_c('vue-chart', {
    ref: "weeklyreport",
    attrs: {
      "data-vv-name": "weeklyreport",
      "name": "weeklyreport",
      "type": "bar",
      "data": _vm.chartData,
      "options": _vm.chartoptions,
      "bind": true,
      "width": _vm.width,
      "height": _vm.height
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step3),
      expression: "step3"
    }],
    staticClass: "step3 clearfix"
  }, [_c('div', {
    staticClass: "downcsv col-md-2 downcsvCFR"
  }, [(_vm.downcsvCRS.length) ? _c('a', {
    ref: "downcsvtrigger",
    staticClass: "btn btn-lrg btn-primary downcsvtrigger",
    attrs: {
      "href": _vm.downcsvCRS,
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download CSV\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group selectchannel col-md-6"
  }, [_c('label', [_vm._v("Select a Last Click Channel")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selchannels),
      expression: "selchannels"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-name": "channels",
      "name": "channels"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selchannels = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectedChannel(_vm.selchannels, 'crs')
      }]
    }
  }, _vm._l((_vm.ofthechannels), function(ofthechannels) {
    return _c('option', {
      key: ofthechannels.key,
      domProps: {
        "value": ofthechannels
      }
    }, [_vm._v(_vm._s(ofthechannels))])
  }), 0)])]), _vm._v(" "), (_vm.selchannels.length !== 0 && _vm.selchannels !== 'all_channels') ? _c('div', {
    staticClass: "chartWrapper"
  }, [_c('div', {
    staticClass: "forecast_charts"
  }, [_c('vue-chart', {
    ref: "creditflowreport",
    attrs: {
      "data-vv-name": "creditflowreport",
      "name": "creditflowreport",
      "type": "bar",
      "chart-data": _vm.creditflowchartData,
      "data": _vm.creditflowchartData,
      "options": _vm.creditflowchartoptions,
      "bind": true,
      "width": _vm.width,
      "height": _vm.height
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-th-large",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e7e9147"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Jobdashboard.vue
// module id = 994
// module chunks = 1